import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-toastify@11.0.5_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/advertisements/components/advertisement-wrapper.tsx");
